<template>
  <!-- 对话框 -->
  <el-dialog
    :visible.sync="show"
    width="500px"
    :before-close="closeDialog"
    center
  >

    <div
      style="max-height: 50vh ;overflow-y: auto;"
      class="box"
    >
      <el-form label-width="80px">

        <el-form-item
          label="系统备注:"
          label-width='120px'
        >

          <el-input v-model="submit_data.system_remarks"></el-input>

        </el-form-item>

      </el-form>

    </div>

    <!-- 对话框底部按钮 -->
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="orderPaySubmit"
        type="primary"
      >确认</el-button>
      <el-button @click="closeDialog">返回</el-button>
    </span>

  </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data.order_code = _this.data;
        }
    },
    data() {
        return {
            show: false,

            // 表单数据
            submit_data: {
                order_code: '',
                system_remarks: ''
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        orderPaySubmit() {
            _this
                .$post('/admin.php/order/editOrderSubmit', _this.submit_data)
                .then((res) => {
                    _this.$message.success(res.msg);

                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((res) => {});
        },

        closeDialog() {
            _this.submit_data = {
                order_code: '',
                system_remarks: ''
            };
            _this.show = false;
        }
    }
};
</script>

<style scoped>
#container_add {
    height: 90%;
    width: 65%;
    float: left;
}

.order-model {
    margin: 20px 0;
}

.mode-data {
    margin: 20px 0;
}

iframe {
    width: 100%;
    border: medium none;
    height: 100%;
}

h4 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
}

h5 {
    font-size: 20px;
    font-weight: normal;
}

.text-btn {
    font-size: 18px;
    margin-left: 20px;
    padding: 5px;
    display: block;
}

.box > div {
    margin: 20px 0;
}
</style>